import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { CompanyHubIcon } from '@atlaskit/temp-nav-app-icons/company-hub';

import type { GlobalShortcutsItem } from '../../types';

import { messages } from './messages';

export default function companyHub(fallbackUrl: () => string, label?: string): GlobalShortcutsItem {
	return {
		icon: <CompanyHubIcon size="20" />,
		label: label ?? <FormattedMessage {...messages.label} />,
		fallbackUrl,
	};
}
